import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-qrcode',
  templateUrl: './manual-qrcode.component.html',
  styleUrls: ['./manual-qrcode.component.css'],
  standalone: false,
})
export class ManualQrcodeComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly qrcodeResultLink: string = AppConst.ROUTING_LINK_MANUAL_QRCODE_RESULT;
  readonly urlResultLink: string = AppConst.ROUTING_LINK_MANUAL_URL_RESULT;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
